/* eslint-disable multiline-ternary */
import React, { useState, useEffect } from 'react'
import { Input, Button, Flex, FormLabel, FormControl } from '@chakra-ui/react'
import { styles } from '../styles'

interface JoinViewProps {
  // mode: string
  // clientInfo: { playerName: string; roomCode: string }
  joinRoom: (clientInfo: { playerName: string; roomCode: string }) => void
}

const JoinView: React.FC<JoinViewProps> = ({ joinRoom }) => {
  const [hideRoomCodeInput, setHideRoomCodeInput] = useState(false)
  const [JVRoomCode, setJVRoomCode] = useState('')
  const [JVplayerName, setJVPlayerName] = useState(
    import.meta.env.MODE === 'development' ? 'Dev' : ''
  )
  const [hideNav, setHideNav] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const roomCode = params.get('room-code')
    const name = params.get('name')
    if (name != null) {
      setJVPlayerName(name)
    }
    if (params.get('mobile-no-nav') === 'true') {
      setHideNav(true)
    }
    if (roomCode != null && roomCode.length === 4) {
      setJVRoomCode(roomCode.toUpperCase())
      setHideRoomCodeInput(true)
    }
  }, [])

  return (
    <Flex sx={{ ...styles.container, ...styles.joinRoom }} p="20px">
      {hideNav ? (
        <style
          dangerouslySetInnerHTML={{ __html: 'header { display: none; }' }}
        />
      ) : null}
      <FormLabel>
        Name
        <FormControl sx={styles.inputWrapper}>
          <Input
            value={JVplayerName}
            placeholder="Enter your Name"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setJVPlayerName(event.target.value)
            }}
          />
          <div className="bend" />
        </FormControl>
      </FormLabel>
      {!hideRoomCodeInput && (
        <FormLabel>
          Room Code
          <FormControl sx={styles.inputWrapper} isRequired={true}>
            <Input
              value={JVRoomCode}
              placeholder="Enter 4 Character Room Code"
              autoComplete="off"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setJVRoomCode(
                  event.target.value
                    .replace(/[^a-zA-Z]/g, '')
                    .toUpperCase()
                    .slice(0, 4)
                )
              }}
            />
            <div className="bend" />
          </FormControl>
        </FormLabel>
      )}
      <Button
        isDisabled={
          JVRoomCode.length !== 4 ||
          JVplayerName === '' ||
          JVplayerName.length > 14
        }
        variant="outlineNegative"
        onClick={() => {
          joinRoom({
            roomCode: JVRoomCode,
            playerName: JVplayerName
          })
        }}
      >
        Join Room
      </Button>
    </Flex>
  )
}

export default JoinView
